import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api
      .get("/gallery")
      .then((r) => mounted && setImages(r.data || []))
      .catch(() => mounted && setImages([]))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="trio-section py-24 lg:py-32 border-b border-[var(--trio-border)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-6">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[var(--trio-primary)] font-bold mb-4">
              The Room · The Plates · The Nights
            </div>
            <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.9]">
              Inside <span className="text-[var(--trio-primary)]">Trio.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-base lg:text-lg text-[var(--trio-muted)] leading-relaxed">
              Real photos from the room. Flyers, events, and the kind of nights
              regulars come back for.
            </p>
          </div>
        </div>

        <div
          data-testid="gallery-grid"
          className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px] md:auto-rows-[220px]"
        >
          {loading &&
            Array.from({ length: 8 }).map((_, i) => (
              <div
                key={`ph-${i}`}
                className="bg-[var(--trio-surface)] animate-pulse"
                data-testid={`gallery-placeholder-${i}`}
              />
            ))}
          {!loading &&
            images.map((img, i) => (
              <div
                key={img.id || i}
                className={`relative overflow-hidden group ${img.span || ""}`}
                data-testid={`gallery-img-${i}`}
              >
                <img
                  src={img.url}
                  alt={img.alt || ""}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
            ))}
          {!loading && images.length === 0 && (
            <div className="col-span-full text-center text-sm text-[var(--trio-muted)] py-12">
              Gallery is being updated. Check back soon.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
